import { create } from 'zustand';
import { FiltersCollection } from '@libs/store/filters';
import { ShiftTypePresetListItem } from '@libs/models/shiftTemplates';
import { fetchShiftTypePresetsList } from '@libs/api/shiftTypes';

type InitialState = {
  initialized: boolean;
  loading: boolean;
  list: ShiftTypePresetListItem[];
  load: (filters: FiltersCollection) => Promise<void>;
  deinit: () => void;
};

export const useShiftTypePresetsList = create<InitialState>()((set) => ({
  initialized: false,
  loading: false,
  list: [],
  load: async (filters) => {
    set({ loading: true });
    try {
      const resp = await fetchShiftTypePresetsList({ filters });
      const { items } = resp;
      set({
        loading: false,
        list: items,
        initialized: true,
      });
    } finally {
      set({ loading: false, initialized: true });
    }
  },
  deinit: () => set({ initialized: false, loading: false, list: [] }),
}));
